import React, { useState } from 'react';
import { Play, Radio, Video, Users, Globe, Zap, Shield, Headphones} from 'lucide-react';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';

import Footer from '../../components/footer/index';
import BroadcastPackages from '../../components/navbar/internet/Internet-broadcast/produk';

const InternetBroadcast = () => {
  const { isDarkMode } = useDarkMode();
  // const [selectedPackage, setSelectedPackage] = useState(0);
  const [activeTab, setActiveTab] = useState('streaming');

  const broadcastFeatures = [
    {
      icon: <Video className="w-8 h-8" />,
      title: "4K/8K Streaming",
      description: "Streaming berkualitas ultra high definition dengan bandwidth yang stabil dan konsisten",
      color: "bg-blue-500"
    },
    {
      icon: <Radio className="w-8 h-8" />,
      title: "Live Broadcasting",
      description: "Siaran langsung tanpa delay dengan teknologi real-time streaming terdepan",
      color: "bg-purple-500"
    },
    {
      icon: <Globe className="w-8 h-8" />,
      title: "Global CDN",
      description: "Jaringan distribusi konten global untuk jangkauan audiens di seluruh dunia",
      color: "bg-green-500"
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Ultra Low Latency",
      description: "Latensi minimal untuk interactive streaming dan gaming broadcast",
      color: "bg-yellow-500"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "DDoS Protection",
      description: "Perlindungan berlapis dari serangan DDoS dan ancaman keamanan lainnya",
      color: "bg-red-500"
    },
    {
      icon: <Headphones className="w-8 h-8" />,
      title: "24/7 Support",
      description: "Tim teknis berpengalaman siap membantu 24 jam setiap hari",
      color: "bg-indigo-500"
    }
  ];

  const useCases = {
    streaming: [
      {
        title: "Gaming Streamers",
        description: "Streaming game dengan kualitas 4K dan interaksi real-time dengan audiens",
        image: "/image/Broadcast/Gaming.png",
        requirements: "Upload: 50+ Mbps, Latency: <5ms"
      },
      {
        title: "Content Creators",
        description: "Upload konten video berkualitas tinggi dan live streaming multi-platform",
        image: "/image/Broadcast/content_creators.png",
        requirements: "Upload: 100+ Mbps, Bandwidth: Dedicated"
      }
    ],
    broadcasting: [
      {
        title: "TV Stations",
        description: "Siaran televisi digital dengan kualitas broadcast professional",
        image: "/image/Broadcast/TV.png",
        requirements: "Dedicated Line, SLA 99.9%"
      },
      {
        title: "Radio Stations",
        description: "Streaming audio berkualitas tinggi untuk radio online dan podcast",
        image: "/image/Broadcast/Radio.png",
        requirements: "Stable Connection, Low Jitter"
      }
    ],
    events: [
      {
        title: "Live Events",
        description: "Siaran langsung acara, konser, dan event dengan multiple camera angles",
        image: "/image/Broadcast/Live_Events.png",
        requirements: "High Upload, Multiple Streams"
      },
      {
        title: "Corporate Events",
        description: "Webinar, meeting, dan presentasi perusahaan dengan kualitas professional",
        image: "/image/Broadcast/Corporate_Events.png",
        requirements: "Stable Connection, HD Quality"
      }
    ]
  };

  const testimonials = [
    {
      name: "Ahmad Rizky",
      role: "Gaming Streamer",
      company: "RizkyGaming Channel",
      rating: 5,
      comment: "Sejak pakai NetSpeedPro Broadcast, streaming saya jadi lancar tanpa lag. Viewers pun makin banyak karena kualitas video yang stabil!",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop&crop=face"
    },
    {
      name: "Sari Indah",
      role: "Content Creator",
      company: "Beauty & Lifestyle",
      rating: 5,
      comment: "Upload video 4K sekarang cuma butuh beberapa menit. Kualitas internetnya konsisten, cocok banget buat content creator seperti saya.",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=60&h=60&fit=crop&crop=face"
    },
    {
      name: "PT. Media Prima",
      role: "IT Manager",
      company: "Television Broadcasting",
      rating: 5,
      comment: "Untuk siaran TV kami, stability dan reliability internet adalah yang utama. NetSpeedPro memberikan exactly yang kami butuhkan.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop&crop=face"
    }
  ];

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900' : '#dfe4e0ff'
    }`}>

      
      
      {/* Hero Section */}
      <section
        className={`py-20 px-4 relative overflow-hidden ${
          isDarkMode
            ? 'bg-gray-900'
            : 'bg-[#dfe4e0ff]'
        } bg-cover bg-center`}
        style={{
          backgroundImage: "url('https://telnet.net.id/assets/bg.png')", // ganti dengan path gambar kamu
          backgroundBlendMode: "overlay",
        }}
      >
        {/* Overlay tipis */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1E9B4C]/20 to-green-700/20"></div>

        <div className="container mx-auto relative z-10 mb-20 text-center mt-24"> {/* Menambahkan margin top */}
          <h1
            className={`text-4xl md:text-6xl font-bold mb-12 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}
          >
            Broadcast Like a
            Professional
          </h1>

          <p
            className={`text-xl md:text-2xl max-w-4xl mx-auto mb-8 leading-relaxed ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}
          >
            Solusi internet khusus untuk streaming, broadcasting, dan content creation dengan kualitas enterprise dan dukungan teknis 24/7
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://wa.me/6287778882022" target="_blank" rel="noopener noreferrer">
            <button className="bg-[#1E9B4C] text-white hover:bg-green-700 font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg">
              Konsultasi Gratis
            </button>
            </a>
            <button className="border-2 border-[#1E9B4C] text-[#1E9B4C] hover:bg-[#1E9B4C] hover:text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105">
              Lihat Paket
            </button>
          </div>
        </div>
      </section>

      <section
        className="py-16 px-4 bg-cover bg-center relative overflow-hidden transition-colors duration-300"
        style={{
          backgroundImage: `url('https://telnet.net.id/assets/bg.png')`, // ganti sesuai path gambar background kamu
          backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',  
          backgroundBlendMode: 'overlay',
        }}
      >
        {/* overlay tambahan biar teks lebih jelas */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1E9B4C]/10 to-green-700/10"></div>

        <div className="container mx-auto relative z-10">
          {/* Header */}
          <div className="text-center mb-12">
            <h2
              className={`text-3xl font-bold mb-4 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              Fitur Unggulan untuk Broadcasting
            </h2>
            <p
              className={`text-lg ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              Teknologi terdepan untuk pengalaman broadcast yang sempurna
            </p>
            <div className="w-24 h-1 bg-gradient-to-r from-[#1E9B4C] to-green-600 mx-auto rounded-full mt-4"></div>
          </div>

          {/* Feature Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {broadcastFeatures.map((feature, index) => (
              <div
                key={index}
                className={`
                  group p-6 rounded-xl shadow-lg overflow-hidden 
                  transform hover:scale-105 hover:shadow-2xl transition-all duration-300
                  ${isDarkMode ? 'bg-gray-800' : 'bg-white'}
                `}
              >
                {/* Icon */}
                <div
                  className={`w-16 h-16 rounded-lg flex items-center justify-center text-white mb-4
                    ${feature.color || 'bg-[#1E9B4C]'}
                  `}
                >
                  {feature.icon}
                </div>

                {/* Title */}
                <h3
                  className={`text-xl font-bold mb-3 transition-colors ${
                    isDarkMode
                      ? 'text-white group-hover:text-[#1E9B4C]'
                      : 'text-gray-900 group-hover:text-[#1E9B4C]'
                  }`}
                >
                  {feature.title}
                </h3>

                {/* Description */}
                <p
                  className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}
                >
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Use Cases Section */}
     <section
        className="py-16 px-4 bg-cover bg-center relative overflow-hidden transition-colors duration-300"
        style={{
          backgroundImage: `url('https://telnet.net.id/assets/bg.png')`, // ganti path sesuai background kamu
          backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
          backgroundBlendMode: 'overlay',
        }}
      >
        <div className="container mx-auto relative z-10">
          {/* Header */}
          <div className="text-center mb-12">
            <h2
              className={`text-3xl font-bold mb-4 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              Solusi untuk Berbagai Kebutuhan
            </h2>
          </div>

          {/* Tab Navigation */}
          <div className="flex justify-center mb-8">
            <div
              className={`inline-flex rounded-lg p-1 ${
                isDarkMode ? 'bg-gray-800' : 'bg-white'
              }`}
            >
              {Object.keys(useCases).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                    activeTab === tab
                      ? 'bg-[#1E9B4C] text-white'
                      : isDarkMode
                      ? 'text-gray-300 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {tab === 'streaming'
                    ? 'Streaming'
                    : tab === 'broadcasting'
                    ? 'Broadcasting'
                    : 'Events'}
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {useCases[activeTab].map((useCase, index) => (
              <div
                key={index}
                className={`rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 ${
                  isDarkMode ? 'bg-gray-800' : 'bg-white'
                }`}
              >
                <img
                  src={useCase.image}
                  alt={useCase.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3
                    className={`text-xl font-bold mb-3 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    {useCase.title}
                  </h3>
                  <p
                    className={`mb-4 ${
                      isDarkMode ? 'text-gray-300' : 'text-gray-600'
                    }`}
                  >
                    {useCase.description}
                  </p>
                  <div
                    className={`text-sm font-medium ${
                      isDarkMode ? 'text-[#1E9B4C]' : 'text-[#1E9B4C]'
                    }`}
                  >
                    Requirements: {useCase.requirements}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <BroadcastPackages />

      {/* CTA Section */}
    <section
  className={`py-16 px-4 ${
    isDarkMode ? 'bg-gray-800' : 'bg-[#1E9B4C]'
  }`}
>
  <div className="container mx-auto text-center">
  <h2 className="text-3xl font-bold text-white mb-4">
    Siap untuk Broadcast Professional?
  </h2>
  <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
    Konsultasikan kebutuhan broadcast Anda dengan tim ahli kami dan dapatkan solusi yang tepat
  </p>
  <div className="flex flex-col sm:flex-row gap-4 justify-center">
    <a href="https://wa.me/6283848581998" target="_blank" rel="noopener noreferrer">
      <button className="border-2 border-white text-white hover:bg-white hover:text-[#1E9B4C] font-semibold px-8 py-4 rounded-lg transition-colors duration-200">
        Hubungi Sales
      </button>
    </a>
  </div>
</div>
</section>
<Footer />
</div>

  );
};

export default InternetBroadcast;